import { ReactNode } from "react";

export interface ImageInfo {
  id: string;
  title: string;
  featuredIndex?: number;
  shortText: string;
  longText: ReactNode;

  original: {
    etsyUrl?: string;
    dimentions: string;
    medium: string;
    onCharitySale?: boolean;
  },
  prints?: {
    shortText: string;
    editionSize: number;
    etsyUrl: string;
  }
  cards?: {
    shortText: string;
    etsyUrl: string;
  }
}

const ImageList: Array<ImageInfo> = [
  {
    id: "its-a-snow-day",
    title: "It's a Snow Day",
    original: {
      dimentions: "16 x 20 inches	/ 40.64 x 50.8 cm",
      medium: "Acrylic on canvas",
      etsyUrl: 'https://bhagyapereraart.etsy.com/uk/listing/4397589678/original-acrylic-wildlife-painting-stag'
    },
    // prints: {
    //   editionSize: 25,
    //   shortText: "Stag",
    //   etsyUrl: 'https://www.etsy.com/uk/shop/BhagyaPereraArt'
    // },
    cards: {
      shortText: "Stag",
      etsyUrl: 'https://bhagyapereraart.etsy.com/uk/listing/4398937007/wildlife-art-blank-card-stag-christmas'
    },
    shortText:
      "Inspired by the stillness of winter, this piece reflects the stag's quiet strength and the peaceful magic of a snowy forest.",
    longText: (
      <>
        <p>
          Its a snowy day is an original acrylic painting inspired by the quiet strength and grace of the stag.
        </p>
        <p>
          This piece developed through soft layers of blended blues and whites, creating a smooth, dreamlike background looks like a winter wonderland.
        </p>
        <p>
          The colours were chosen to reflect balance between cool tranquillity of snow and the warm colours of the stag. Hope this painting invites the you to feel both peace and power, a reminder of nature'ss beauty in its most hushed, graceful form.
        </p>
      </>
    ),
    featuredIndex: 2,
  },
  {
    id: "rabbit",
    title: "Whiskers of Wonder",
    original: {
      dimentions: "16 x 20 inches	/ 40.64 x 50.8 cm",
      medium: "Acrylic on canvas",
      etsyUrl: 'https://bhagyapereraart.etsy.com/uk/listing/4397492002/whiskers-of-wonder'
    },
    // prints: {
    //   editionSize: 25,
    //   shortText: "Rabbit",
    //   etsyUrl: 'https://www.etsy.com/uk/shop/BhagyaPereraArt'
    // },
    shortText:
      "Whiskers of Wonder captures the gentle innocence and quiet strength of a rabbit",
    longText: (
      <>
        <p>
          The expressive eyes draw the you in, evoking curiosity, playfulness, and a sense of connection to the natural world.
        </p>
        <p>
          This piece celebrates the simple beauty of wildlife, reminding us to pause and appreciate the wonder in even the smallest creatures.
        </p>
      </>
    ),
    featuredIndex: 1
  },
  {
    id: "kitsune",
    title: "Kitsune",
    original: {
      dimentions: "16 x 20 inches	/ 40.64 x 50.8 cm",
      medium: "Acrylic on canvas",
    },
    prints: {
      editionSize: 30,
      shortText: "Fox",
      etsyUrl: 'https://bhagyapereraart.etsy.com/uk/listing/4398252635/wildlife-art-print-kitsune'
    },
    cards: {
      shortText: "Fox",
      etsyUrl: 'https://bhagyapereraart.etsy.com/uk/listing/4398269123/wildlife-art-blank-card-kitsune'
    },
    shortText:
      "Mysterious, graceful, and ever watchful, the fox has long been a symbol of intelligence and adaptability.",
    longText: (
      <>
        <p>
          In the wild, it moves with a quiet elegance,slipping between shadow and light, embodying both mischief and curiosity.
        </p>
        <p>
          This painting, titled Kitsune, draws inspiration from Japanese folklore, where the mythical fox is celebrated as a shape-shifter and a bearer of wisdom. Through her steady gaze and poised presence, I aimed to capture not only the clever charm of the common fox but also the sense of wonder and enchantment.
        </p>
      </>
    )
  },
  {
    id: "squirrel",
    title: "Peekaboo",
    original: {
      dimentions: "11.8 x 11.8 inches	/ 30 x 30 cm",
      medium: "Acrylic on canvas",
      etsyUrl: 'https://bhagyapereraart.etsy.com/uk/listing/4397562467/peekaboo-red-squirrel-acrylic-painting'
    },
    shortText:
      "Peekaboo is an original acrylic painting inspired by the playful and inquisitive nature of red squirrels.",
    longText: (
      <>
        <p>
          Peekaboo is an original acrylic painting inspired by the playful and inquisitive nature of red squirrels. I wanted to capture that fleeting moment when curiosity takes over, when a tiny face suddenly appears from behind a tree, eyes wide with wonder and mischief.
        </p>
        <p>
          The piece evolved through many layers of fine brushwork, building depth and texture in the fur to reflect the softness and warmth of this little creature. The rich emerald background was chosen to evoke the cool calm of the forest, allowing the squirrel’s golden tones to glow with life and energy.
        </p>
        <p>
          Unlike my more serene wildlife portraits, Peekaboo feels spontaneous and full of personality, a joyful reminder of nature’s liveliness and the small surprises that make us smile.
        </p>
      </>
    )
  },
  {
    id: "the-vanishing-act",
    title: "The Vanishing Act",
    original: {
      dimentions: "16 x 20 inches	/ 40.64 x 50.8 cm",
      medium: "Acrylic on canvas",
      etsyUrl: 'https://bhagyapereraart.etsy.com/uk/listing/4397557942/the-vanishing-act'
    },
    shortText:
      "The Vanishing Act captures the fragile existence of the vaquita.",
    longText: (
      <>
        <p>
          "The Vanishing Act" is a haunting tribute to the rare and endangered vaquita, a species on the brink of extinction. From a distance, the painting reveals the beauty of this elusive marine mammal, its delicate form gliding through the water with quiet grace. But as you step closer or zoom in, the heartbreaking truth emerges,its body begins to dissolve into the background, fading away as if slipping from existence.
        </p>
        <p>
          This visual illusion reflects the dire reality of the vaquita’s plight, with only 6-8 remaining in the wild as of 2024. The Vanishing Act is more than a painting; it is a powerful statement on loss, fragility, and the urgent need for conservation before this magnificent creature disappears forever.
        </p>
      </>
    )
  },
  {
    id: "greybeard",
    title: "Graybeard",
    original: {
      dimentions: "16 x 20 inches	/ 40.64 x 50.8 cm",
      medium: "Acrylic on canvas",
      etsyUrl: 'https://bhagyapereraart.etsy.com/uk/listing/4397569713/graybeard-chimpanzee-acrylic-painting'
    },
    prints: {
      shortText: "Chimpanzee",
      editionSize: 25,
      etsyUrl: 'https://bhagyapereraart.etsy.com/uk/listing/4398246726/wildlife-art-print-graybeard'
    },
    cards: {
      shortText: "Chimpanzee",
      etsyUrl: 'https://bhagyapereraart.etsy.com/uk/listing/4398272947/wildlife-art-blank-card-graybeard'
    },
    shortText:
      "Greybeard is an original acrylic painting inspired by the quiet wisdom and soulful presence of an ageing chimpanzee.",
    longText: (
      <>
        <p>
          Greybeard is an original acrylic painting inspired by the quiet wisdom and soulful presence of an ageing chimpanzee. I wanted to capture that deeply human moment in his gaze,where experience, curiosity, and calm acceptance meet.
        </p>
        <p>
          The painting developed slowly through layers of fine brushwork, each stroke building texture and character into his face. Subtle highlights trace the contours of time, while the warm browns and muted greys bring out the depth and gentleness in his expression.
        </p>
        <p>
          Unlike my lighter, more playful animal portraits, Greybeard carries a sense of stillness, a quiet strength that invites reflection. To me, he represents dignity in age, the intelligence of nature, and the unspoken understanding that connects all living beings.
        </p>
      </>
    ),
    featuredIndex: 3
  },
  {
    id: "stealth",
    title: "Stealth",
    original: {
      dimentions: "16 x 20 inches	/ 40.64 x 50.8 cm",
      medium: "Acrylic on canvas",
      etsyUrl: 'https://bhagyapereraart.etsy.com/uk/listing/4397564028/stealth-cheetah-acrylic-painting'
    },
    prints: {
      editionSize: 50,
      shortText: "Cheetah",
      etsyUrl: 'https://bhagyapereraart.etsy.com/uk/listing/4398259187/wildlife-art-print-stealth'
    },
    cards: {
      shortText: "Cheetah",
      etsyUrl: 'https://bhagyapereraart.etsy.com/uk/listing/4398264074/wildlife-art-blank-card-stealth'
    },
    shortText:
      "Stealth reveals the cheetah's quiet power and focused determination.",
    longText: (
      <>
        <p>
          Stealth is an original acrylic painting inspired by the raw intensity and quiet confidence of the cheetah,nature’s embodiment of grace and power. I wanted to capture that precise moment before motion, when stillness holds all the energy of the chase.
        </p>
        <p>
          Through layers of fine brushwork, I built depth and texture into the fur, each stroke tracing the sleek lines that define this extraordinary predator. The golden eyes were painted with particular care, bright, focused, and filled with quiet determination.
        </p>
        <p>
          Unlike my softer, more contemplative portraits, Stealth carries a pulse of tension and alertness. It’s a study of focus, a reminder of nature’s balance between elegance and ferocity, and the breathtaking beauty found in strength held just before release.
        </p>
      </>
    )
  },
  {
    id: "innocence-illuminated",
    title: "Innocence Illuminated",
    original: {
      dimentions: "16 x 20 inches	/ 40.64 x 50.8 cm",
      medium: "Acrylic on canvas",
      etsyUrl: 'https://bhagyapereraart.etsy.com/uk/listing/4397568684/innocence-illuminated-raccoon-acrylic'
    },
    prints: {
      editionSize: 25,
      shortText: "Racoon",
      etsyUrl: 'https://bhagyapereraart.etsy.com/uk/listing/4398261181/wildlife-art-print-innocence-illuminated'
    },
    cards: {
      shortText: "Racoon",
      etsyUrl: 'https://bhagyapereraart.etsy.com/uk/listing/4398277171/innocence-illuminated'
    },
    shortText:
      "Innocence Illuminated captures the raccoon's vulnerable yet determined gaze.",
    longText: (
      <>
        <p>
          "Innocence Illuminated" captures the essence of a raccoon beyond its playful and mischievous reputation. Though these resilient creatures are thriving, adapting effortlessly to changing environments, there is an undeniable innocence in their wide, searching eyes.  </p>
        <p>
          In this painting, the raccoon’s gaze is illuminated, revealing a deeper story, one of quiet determination, vulnerability, and an unspoken struggle to find its place in an ever-evolving world.
        </p>
      </>
    )
  },
  {
    id: "fallowdeer",
    title: "Willow the deer",
    original: {
      dimentions: "10x12 inches	/ 25.4cm x 30.48cm",
      medium: "Acrylic on canvas",
      etsyUrl: 'https://bhagyapereraart.etsy.com/uk/listing/4397580783/willow-fallow-deer-painting-acrylic'
    },
    shortText:
      "Willow captures the innocence and fragile beauty of a young fallow deer",
    longText: (
      <>
        <p>
          Willow captures the delicate beauty of a young fallow deer, a species with a rich and complex history in Britain. Originally introduced from the western Mediterranean during the Roman era, these graceful deer vanished from the landscape following the empire’s collapse, only to be reintroduced centuries later from the eastern Mediterranean in the 11th century.
        </p>
        <p>
          What first drew me to this subject was the innocence radiating from the baby deer’s gentle gaze. There is something profoundly pure and untarnished in its expression, a quiet curiosity and fragility that I felt compelled to translate onto canvas. Through soft brushstrokes and delicate detailing, I have sought to preserve the charm and grace of this young creature, allowing its presence to speak of both history and the timeless wonder of nature.
        </p>
      </>
    )
  },
  {
    id: "luna",
    title: "Luna the Grass Snake",
    original: {
      dimentions: "10x12 inches	/ 25.4cm x 30.48cm",
      medium: "Acrylic on canvas",
      etsyUrl: 'https://bhagyapereraart.etsy.com/uk/listing/4397576674/luna-the-grass-snake'
    },
    shortText:
      "Luna celebrates the elegance and vibrant beauty of the grass snake.",
    longText: (
      <>
        <p>
          "Luna" is a graceful grass snake, proudly holding the title of Britain’s longest snake. While these reptiles are typically adorned in muted gray and green tones, I have chosen to portray Luna in a more vibrant and colorful rendition, celebrating the beauty often overlooked in these elusive creatures.
        </p>
        <p>
          Through Luna, I aim to highlight not just the elegance of these misunderstood serpents, but also their vital role in our ecosystems. With her poised presence and striking colors, she serves as a reminder of the delicate balance in nature and the importance of preserving these remarkable creatures before they, too, begin to vanish from our wild landscapes.
        </p>
      </>
    )
  },
  {
    id: "stevan",
    title: "Stevan the Puffin",
    original: {
      dimentions: "10x12 inches	/ 25.4cm x 30.48cm",
      medium: "Acrylic on canvas",
      etsyUrl: 'https://bhagyapereraart.etsy.com/uk/listing/4397579476/stevan-the-puffin-original-acrylic'
    },
    shortText:
      "Steven captures the soulful innocence and resilience of the puffin.",
    longText: (
      <>
        <p>
          "Steven" marks the inaugural member of my British Wild Isles mini-series, bringing to life the charm and character of the beloved puffin. These distinctive seabirds grace the rugged shores of the North Atlantic, with the British Isles proudly hosting around 10% of the global puffin population. Yet, despite their endearing appearance, puffins face an uncertain future. Listed as "Vulnerable" on the IUCN Red List and included on the Red List of UK Birds of Conservation Concern, their survival is threatened by habitat loss and environmental changes.
        </p>
        <p>
          What captivates me most about puffins is the innocence reflected in their soulful gaze—a quiet depth that speaks of both fragility and resilience. In Steven, I have sought to capture this poignant expression, contrasting it against a vibrant, colorful background. This juxtaposition highlights not only their delicate plight but also the enduring hope that these remarkable birds continue to inspire.s
        </p>
      </>
    )
  },
  {
    id: "end-of-the-day",
    title: "End of the day",
    original: {
      dimentions: "24x 30 inches	60.96 x 76.2 cm",
      medium: "Acrylic on canvas",
      etsyUrl: 'https://bhagyapereraart.etsy.com/uk/listing/4397590305/end-of-the-day'
    },
    shortText:
      "End of the Day captures the quiet resilience and emotional depth of the horse.",
    longText: (
      <>
        <p>
          "End of the Day" is a tribute to the quiet resilience of the horse. For centuries, these noble creatures have carried our burdens, from warfare to labor, often pushing through exhaustion without rest.  </p>
        <p>
          What captivated me about the original photograph was the unspoken emotion in the horse’s posture—its lowered head and sullen eyes telling a story of weariness, a silent plea for recognition. This became the heart of my painting, where muted, shaded tones echo the fatigue and quiet sadness felt after a long day’s work.
        </p>
        <p>
          Through End of the Day, I wanted to capture more than just an image; I sought to evoke empathy, reminding us to look beyond their strength and see the depth of their emotions, their sacrifices, and their enduring spirit.
        </p>
      </>
    )
  },
  {
    id: "reflect",
    title: "Reflect",
    original: {
      dimentions: "24x 30 inches	60.96 x 76.2 cm",
      medium: "Acrylic on canvas",
      etsyUrl: 'https://bhagyapereraart.etsy.com/uk/listing/4397584576/reflect'
    },
    shortText:
      "Reflect is a poignant tribute to the endangered sea turtle.",
    longText: (
      <>
        <p>
          "Reflect" is a poignant tribute to the endangered sea turtle, a species pushed to the brink by human activity. Classified as endangered by the WWF, these ancient mariners face relentless threats—from pollution to habitat destruction and accidental entanglement in fishing nets.
        </p>
        <p>
          When I first saw the original photograph, I was struck by the turtle’s contemplative stillness, as if hesitating before surfacing, remembering those who never returned. This moment of uncertainty became the heart of my painting—an emotional reflection on loss, survival, and the fragile balance between nature and human impact.
        </p>
        <p>
          A dim light gently illuminates the scene, symbolizing a glimmer of hope, a reminder of the tireless efforts by organizations working to protect these magnificent creatures. Reflect is not just a painting; it is a call to action—urging us to reconsider our choices and take responsibility for the future of these endangered animals.
        </p>
      </>
    )
  },
  {
    id: "focus",
    title: "Focus",
    original: {
      dimentions: "16 x 20 inches	/ 40.64 x 50.8 cm",
      medium: "Acrylic on canvas",
      etsyUrl: 'https://bhagyapereraart.etsy.com/uk/listing/4397587354/focus-owl-acrylic-painting-wildlife'
    },
    prints: {
      editionSize: 30,
      shortText: "Focus : The Great horned owl.",
      etsyUrl: 'https://bhagyapereraart.etsy.com/uk/listing/4398253468/wildlife-art-print-focus'
    },
    cards: {
      shortText: "Focus : The Great horned owl.",
      etsyUrl: 'https://bhagyapereraart.etsy.com/uk/listing/4398271141/wildlife-art-blank-card-focus'
    },
    shortText:
      "Focus captures the piercing gaze and quiet power of the great horned owl.",
    longText: (
      <>

        <p>
          "Focus" captures the commanding presence of the great horned owl, a bird renowned for its adaptability and silent precision. Their resilience in the face of environmental change is remarkable, yet they are not immune to modern threats—pesticides used for rodent control continue to pose a danger to their survival.
        </p>
        <p>
          What first captivated me about this owl was the sheer intensity of its gaze,its piercing eyes radiate wisdom, strength, and an unyielding focus. The richness of its colors presented an exciting challenge. Focus is more than a portrait; it is an homage to the quiet power and unwavering spirit of this extraordinary predator.
        </p>
      </>
    ),
    featuredIndex: 4,
  },
  {
    id: "the-stare",
    title: "The Stare",
    original: {
      dimentions: "39.3 x 19.6in /100 x 50 cm",
      medium: "Acrylic on canvas",
    },
    shortText:
      "The Stare honors the raw power and regal presence of the lion, capturing its strength.",
    longText: (
      <>
        <p>
          "The Stare" is a tribute to the raw power and regal presence of the lion, a species classified as vulnerable and in need of protection. As one of the most iconic animals in the world, the thought of these majestic creatures fading into history is unimaginable. When I first saw the original photograph, I was captivated by its piercing gaze, its proud posture embodying the strength, dominance, and courage that define the king of the jungle.
        </p>
        <p>
          Painting a lion was a deeply personal yet new challenge for me—one that demanded patience, precision, and weeks of dedication. But every brushstroke was worth it, as the final piece does justice to the magnificence of these incredible beings. Now, "The Stare" hangs proudly in my living room, watching over us from its rightful throne, just as a true king should.
        </p>
      </>
    )
  },
  {
    id: "the-look-of-love",
    title: "The look of love",
    original: {
      dimentions: "10x12 inches	/ 25.4cm x 30.48cm",
      medium: "Acrylic on canvas",
    },
    shortText:
      "This puppy painting holds a special place among our family's favorites.",
    longText: (
      <>
        <p>
          "The Look of Love" is a painting that holds a special place in our hearts, capturing the pure and unfiltered innocence of a puppy’s gaze.
        </p>
        <p>
          Though not a portrait of a family pet, this little one’s expression radiates warmth, trust, and unconditional love—qualities that make dogs such cherished companions.
        </p>
      </>
    )
  },
  {
    id: "buddha",
    title: "Lord Gauthama Buddha",
    original: {
      dimentions: "24x 30 inches/ 60.96 x 76.2 cm",
      medium: "Acrylic on canvas",
    },
    shortText:
      "This painting blends contemporary style with the timeless wisdom and serene presence of Buddha, capturing his enduring kindness.",
    longText: (
      <>
        <p>
          This painting is one of my earliest creations, inspired by Buddha’s everlasting gesture of kindness.
        </p>
        <p>
          While I embraced a contemporary approach, I sought to capture the essence of his wisdom and serene presence, reflecting his timeless influence.
        </p>
      </>
    )
  },
  {
    id: "elephant",
    title: "The Elephant.",
    original: {
      dimentions: "24x 30 inches / 60.96 x 76.2 cm",
      medium: "Acrylic on canvas",
    },
    shortText:
      "The Elephant honors the deep bond between Sri Lankans and their revered elephants.",
    longText: (
      <>
        <p>
          "he Elephant" captures the deep bond between Sri Lankans and their revered elephants, creatures that hold a sacred place in the nation’s cultural and spiritual heritage.
        </p>
        <p>
          When I first encountered the original photograph, I was immediately drawn to the gentle giant’s soulful expression—a quiet yet powerful reflection of the deep connection shared between humans and elephants. Through this painting, I aim to honor their beauty, dignity, and the profound role they continue to play in our hearts and history.
        </p>
      </>
    )
  },
  {
    id: "the-wise-one",
    title: "The wise one",
    original: {
      dimentions: "24 x 30 inches / 60.96 x 76.2 cm",
      medium: "Acrylic on canvas",
    },
    shortText:
      "The Wise One pays tribute to the critically endangered Cross River gorilla.",
    longText: (
      <>
        <p>
          "The Wise One" is a tribute to the rare and critically endangered Cross River gorilla, a species on the brink of survival. Every encounter with these extraordinary beings leaves me in awe—their complex behaviors, unique personalities, and deeply expressive eyes reveal a world of intelligence and emotion.
        </p>
        <p>
          In this painting, the gorilla’s gaze is filled with quiet wisdom and an unspoken resilience, a reflection of both struggle and hope. The name "The Wise One" was inspired by this very expression—one that reminds us of the delicate balance between survival and extinction, urging us to protect and cherish these magnificent creatures before it’s too late.
        </p>
      </>
    )
  },
  {
    id: "trust-the-wait",
    title: "Trust the wait",
    original: {
      dimentions: "24 x 30 inches / 60.96 x 76.2 cm",
      medium: "Acrylic on canvas",
    },
    shortText:
      "Trust the Wait captures the quiet resilience and hopeful patience of a young snow leopard cub.",
    longText: (
      <>
        <p>
          "Trust the Wait" captures the quiet resilience of the magnificent snow leopard, a species classified as vulnerable and in urgent need of protection. In this painting, a young cub gazes into the horizon, its eyes filled with a glimmer of hope and uncertainty.
        </p>
        <p>
          There is a quiet patience in its expression—a deep understanding that survival is a long and unpredictable journey. Yet, despite the challenges, the cub trusts in the rhythm of nature, holding onto the promise of a future not just for itself, but for its entire species. Through this piece, I hope to reflect both the fragility and strength of these elusive cats, reminding us of our role in safeguarding their existence.
        </p>
      </>
    )
  },
  {
    id: "elephantfamily",
    title: "Family",
    original: {
      dimentions: "40x32 inches	101.6 x 81.28 cm",
      medium: "Acrylic on canvas",
    },
    shortText:
      "Family celebrates the unbreakable bond of love and protection within an elephant herd",
    longText: (
      <>
        <p>
          "Family" is a heartfelt tribute to the unbreakable bond within an elephant herd, a connection that mirrors the love and protectiveness found in our own families. Growing up, I learned about the Thunpath Raana—a formidable trio of elephants consisting of a father, a mother or sister, and their calf. Their unwavering devotion to safeguarding the young one, even at the cost of their own lives, is a powerful testament to the depth of familial love.
        </p>
        <p>
          his painting resonates deeply with me, reflecting the same fierce protectiveness and unconditional love I hold for my own family—my husband and son. Through "Family," I hope to celebrate this universal connection, one that transcends species and speaks to the very essence of love, unity, and resilience.
        </p>
      </>
    )
  }
];

export default ImageList;
